// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/no-explicit-any */
import {GraphQLClient} from 'graphql-request';

import {PUBLIC_BACKEND_BASE_URL, isDevBuild} from './constants';
import {signOutApiCall} from '~/hooks';

export interface QueryError {
  message: string;
  locations: {line: number; column: number}[];
  path: string[];
  extensions: {code: string; exception: any};
}

interface IQueryBE<T extends (...arg: any) => any> {
  query: string;
  variables: Record<string, Parameters<T>[0]> | Parameters<T>[0];
  caller?: 'server' | 'client';
  headers?: HeadersInit;
  options?: any;
  token?: string;
}
export async function queryBe<
  queryName extends string,
  T extends (...args: any) => any,
>({
  query,
  variables,
  caller = 'server',
  headers,
  options,
  token,
}: IQueryBE<T>): Promise<{
  data: Record<queryName, Awaited<ReturnType<T>>>;
  errors?: QueryError[];
}> {
  const res = await fetch(`${PUBLIC_BACKEND_BASE_URL}/fe/graphql`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...headers,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
    ...options,
  });

  const jsonResponse = await res.json();

  // Check if caller is client
  if (caller === 'client') {
    const errorCode = getQueryBeErrorCode(jsonResponse);

    // Logout if error is UNAUTHENTICATED
    if (errorCode === 'UNAUTHENTICATED') {
      await signOutApiCall();
      window.location.replace('/account/login');
    }
  }

  if (res.status >= 400) {
    throw new Error(await res.text());
  }

  return jsonResponse;
}

export const graphqlClient = new GraphQLClient(
  `${PUBLIC_BACKEND_BASE_URL}/fe/graphql`,
  {
    credentials: 'include',
    mode: 'cors',
    errorPolicy: 'all',
  },
);

export const getQueryBeErrorCode = (jsonResponse: any): string => {
  return (
    (jsonResponse?.errors && jsonResponse.errors[0]?.extensions?.code) ?? ''
  );
};
